import React from 'react'
import styled, { keyframes } from 'styled-components'

const shimmer = keyframes`
  0% { background-position: -200px 0; }
  100% { background-position: calc(200px + 100%) 0; }
`

const SkeletonRoot = styled.div`
  height: ${({ $height }) => (typeof $height === 'number' ? `${$height}px` : $height)};
  width: ${({ $width }) => (typeof $width === 'number' ? `${$width}px` : $width)};
  border-radius: ${({ $circle, $borderRadius }) => ($circle
    ? '50%'
    : (typeof $borderRadius === 'number' ? `${$borderRadius}px` : $borderRadius))};
  background: linear-gradient(90deg, rgba(0,0,0,0.06) 25%, rgba(0,0,0,0.12) 37%, rgba(0,0,0,0.06) 63%);
  background-size: 200px 100%;
  animation: ${shimmer} 1.4s ease infinite;
`

export function Skeleton({ height = '1em', width = '100%', borderRadius = 6, circle = false, style }) {
  return (
    <SkeletonRoot
      $height={height}
      $width={width}
      $borderRadius={borderRadius}
      $circle={circle}
      style={style}
    />
  )
}
